"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const MiniProviderContent_1 = require("../MiniProviderContent");
const MiniProviderCard_styles_1 = require("./MiniProviderCard.styles");
const ViewAvailabilityButton_1 = __importDefault(require("./ViewAvailabilityButton"));
const ViewProfileButton_1 = __importDefault(require("./ViewProfileButton"));
/**
 * A component for rendering small, interactive provider cards.
 */
const MiniProviderCard = (0, react_1.forwardRef)((_a, ref) => {
    var { hideFields = [], provider, config, availability, onViewAvailability, viewAvailabilityUrl, onViewProvider, viewProviderUrl, location, viewAvailabilityLinkTarget, viewProviderLinkTarget, isProfileDisabled = false, onViewProviderCTA } = _a, restProps = __rest(_a, ["hideFields", "provider", "config", "availability", "onViewAvailability", "viewAvailabilityUrl", "onViewProvider", "viewProviderUrl", "location", "viewAvailabilityLinkTarget", "viewProviderLinkTarget", "isProfileDisabled", "onViewProviderCTA"]);
    return (react_1.default.createElement(MiniProviderCard_styles_1.CardContainer, Object.assign({}, restProps, { ref: ref, "data-ref": ref ? 'set' : 'unset' }),
        react_1.default.createElement(MiniProviderContent_1.MiniProviderContent, { availability: availability, compactProviderSpecialties: true, config: config, hideFields: hideFields, location: location, onViewProvider: onViewProvider, provider: provider, viewProviderUrl: viewProviderUrl, viewProviderLinkTarget: viewProviderLinkTarget, isProfileDisabled: isProfileDisabled }),
        !!viewAvailabilityUrl && (react_1.default.createElement(ViewAvailabilityButton_1.default, { config: config, provider: provider, availability: availability, onViewAvailability: onViewAvailability, viewAvailabilityUrl: viewAvailabilityUrl, viewAvailabilityLinkTarget: viewAvailabilityLinkTarget })),
        !viewAvailabilityUrl && !isProfileDisabled && (react_1.default.createElement(ViewProfileButton_1.default, { config: config, provider: provider, availability: availability, onViewProviderCTA: onViewProviderCTA, viewProviderUrl: viewProviderUrl, viewProviderLinkTarget: viewProviderLinkTarget }))));
});
MiniProviderCard.displayName = 'MiniProviderCard';
exports.default = MiniProviderCard;
//# sourceMappingURL=MiniProviderCard.js.map